import {EventEmitter} from 'eventemitter3'

export const fileEvent = new EventEmitter()

export const fileEventTypes = {
    // Import
    NOTIFY_IMPORT_RESULT: 'NOTIFY_IMPORT_RESULT',
    // Export
    GET_EXPORT_COLUMNS_DATA: 'GET_EXPORT_COLUMNS_DATA',
    RECEIVE_EXPORT_COLUMNS_DATA: 'RECEIVE_EXPORT_COLUMNS_DATA',
}

export function getFileEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case fileEventTypes.NOTIFY_IMPORT_RESULT:
            return `NOTIFY_IMPORT_RESULT_${tableType}`
        case fileEventTypes.GET_EXPORT_COLUMNS_DATA:
            return `GET_EXPORT_COLUMNS_DATA_${tableType}`
        case fileEventTypes.RECEIVE_EXPORT_COLUMNS_DATA:
            return `RECEIVE_EXPORT_COLUMNS_DATA_${tableType}`
        default:
            return ''
    }
}

export function onNotifyImportResultListener(tableType, value) {
    if (!tableType) {
        return
    }

    fileEvent.emit(
        `${getFileEventKey(tableType, fileEventTypes.NOTIFY_IMPORT_RESULT)}`,
        value,
    )
}

export function onGetExportColumnsDataListener(tableType, exportColumnType) {
    if (!tableType) {
        return
    }

    fileEvent.emit(
        `${getFileEventKey(tableType, fileEventTypes.GET_EXPORT_COLUMNS_DATA)}`,
        exportColumnType,
    )
}

export function onReceiveExportColumnsDataListener(tableType, columns) {
    if (!tableType) {
        return
    }

    fileEvent.emit(
        `${getFileEventKey(
            tableType,
            fileEventTypes.RECEIVE_EXPORT_COLUMNS_DATA,
        )}`,
        columns,
    )
}

export function removeFileEventListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    fileEvent.removeListener(getFileEventKey(tableType, eventType))
}
